import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { from, Subject } from 'rxjs';
import { GenericErrorResponse } from '../../../../../core/models/generic-response.model';
import { ReferentialsImmobilisationDemandeService } from '../referentials-immobilisation-demande.service';
import { HttpErrorResponse } from '@angular/common/http';
import { InlineResponse } from '../../../../../core/models/inline-response.model';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { provideTranslocoScope, TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-add-raison',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, DynamicDialogModule, InputTextModule, InputGroupModule, InputGroupAddonModule, ReactiveFormsModule, ToastModule, MessagesModule, MessageModule, ProgressSpinnerModule, TranslocoModule],
  providers: [DialogService, MessageService, provideTranslocoScope({ scope: 'referentiels' })],
  templateUrl: './add-raison-immobilisation.component.html',
  styleUrl: './add-raison-immobilisation.component.css',
})
export class AddRaisonImmobilisationComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  disableSubmit = false;
  errors: GenericErrorResponse[] = [];
  submitting: boolean = false;

  raisonImmobilisationForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private ref: DynamicDialogRef,
    private immobilisationDemandeService: ReferentialsImmobilisationDemandeService,
    private messageService: MessageService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.raisonImmobilisationForm = this.formBuilder.group({
      raison: ['', [Validators.required, Validators.maxLength(150)]],
    });
  }

  addRaisonImmobilisation() {
    this.submitting = true;
    const raison = this.raisonImmobilisationForm.controls.raison.value;

    this.immobilisationDemandeService.addRaisonImmobilisation(raison).subscribe({
      next: (response) => {
        this.handleInlineResponse(response);
        this.submitting = false;
      },
      error: (error) => {
        this.handleHttpErrorResponse(error);
      },
    });
  }

  private handleInlineResponse(response: InlineResponse): void {
    this.disableSubmit = false;
    if (response.success) {
      this.close(true);
    } else {
      this.errors = response.errors;
      this.messageService.add({
        severity: 'error',
        summary: this.translocoService.translate('error.popup.titre.defaut'),
        detail: 'Une erreur est survenue : ' + this.errors.map((e) => e.errorMsg).join(', '),
        life: 3000,
      });
    }
  }

  private handleHttpErrorResponse(error: HttpErrorResponse) {
    this.disableSubmit = false;
    this.errors = [];
    this.errors.push({
      errorInputId: error.status.toString(),
      errorCode: error.status.toString(),
      errorMsg: error.statusText,
    } as GenericErrorResponse);
    this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue : ' + error.statusText, life: 3000 });
  }

  close(result: boolean): void {
    this.ref.close(result);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
